
<div class="sw-cms-block-product-finder">
    <slot name="content">

        {% block sw_cms_block_product_finder %}{% endblock %}
    </slot>
</div>